import { render, staticRenderFns } from "./table.vue?vue&type=template&id=564d78d6&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=564d78d6&prod&lang=less&scoped=true"
import style1 from "./table.vue?vue&type=style&index=1&id=564d78d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d78d6",
  null
  
)

export default component.exports